import http from '../../http'

const getAccelerator = async (id, query) => {
  const options = {
    params: {...query, page: query.page ? query.page : 1}
  }
  
  return await http.get(`campaigns/${id}/accelerators`, options)
}

export const getAllAccelerators = async (campaignId) => {
  return http.get(`campaigns/${campaignId}/accelerators/all`)
}

export const excludeAcceleratorsPartner = async (campaignId, partnerId, acceleratorIds) => {
  return http.post(`campaigns/${campaignId}/accelerators/partner/${partnerId}/exclude`, { acceleratorIds })
}

const getAcceleratorDetails = async (id, campaign) =>
  await http.get(`campaigns/${campaign}/accelerators/${id}`)

const insertAccelerator = async (id, payload) =>
  await http.post(`campaigns/${id}/accelerators/`, payload)

const updateAccelerator = async (id, accelerator, payload) =>
  await http.patch(`campaigns/${id}/accelerators/${accelerator}`, payload)

const updateAcceleratorsStatus = async (id, payload) => {
  await http.patch(`campaigns/${id}/accelerators/`, payload)
}

export {
  getAccelerator,
  insertAccelerator,
  updateAccelerator,
  getAcceleratorDetails,
  updateAcceleratorsStatus
}
